<template>
  <div>
    <div v-if="loading && meals.length === 0" :class="$style.loadingBox">
      <a-spin />
    </div>
    <a-list
      v-else-if="meals.length === 0"
      :data-source="[]"
      :locale="{ emptyText: $t('cantine.menuIntrouvable') }"
    />
    <a-spin v-else :spinning="loading">
      <div :class="$style.items">
        <div
          v-for="(item, index) in meals"
          :key="item._id || index"
          :class="$style.item"
        >
          <div :class="$style.itemContent">
            <div :class="$style.itemControl">
              <div :class="$style.itemControlContainer">
                <a-button-group>
                  <a-button icon="edit" @click="$emit('edit', item)" />
                  <a-popconfirm
                    :title="$t('requis.supp')"
                    :ok-text="$t('all.oui')"
                    :cancel-text="$t('all.non')"
                    @confirm="$emit('delete', item)"
                  >
                    <a-button icon="delete" />
                  </a-popconfirm>
                </a-button-group>
              </div>
            </div>
            <img
              v-if="item.file"
              :src="settings.resourcesUrl.replace('FILE_PATH', item.file)"
              alt="Image"
              style="object-fit: cover; width: 100%; height: 100%"
            />
            <div v-else :class="$style.placeholder">
              <a-icon type="picture" style="font-size: 30px; color: #999" />
            </div>
          </div>
          <div class="text-gray-6">
            <div>
              {{ getCategoryTranslation(item.category) + " : " + item.name }}
            </div>
          </div>
        </div>
      </div>
    </a-spin>
  </div>
</template>
<script>
import { mapState } from "vuex";

export default {
  name: "MealList",
  props: {
    meals: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState(["settings"]),
  },
  methods: {
    getCategoryTranslation(category) {
      const categoryMap = {
        dessert: this.$t("cantine.dessert"),
        platP: this.$t("cantine.plat"),
        entree: this.$t("cantine.entree"),
        goute: this.$t("cantine.goute"),
        boissons: this.$t("cantine.boissons"),
        autre: this.$t("cantine.autre"),
      };
      return categoryMap[category] || category;
    },
  },
};
</script>
<style lang="scss" module>
@import "../style.module.scss";

.loadingBox {
  min-height: rem(220);
  display: flex;
  align-items: center;
  justify-content: center;
}

.placeholder {
  background-color: #f5f5f5;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
